import PropTypes from 'prop-types';
import React from 'react';
import qs from 'query-string';
import { useLocation } from 'react-router-dom';

import Button from 'components/Button';

/**
 * [WizardBackButton] - handles rendering the back button used in either the WizardStep or WizardOverview
 * components
 *
 * @param {string} [backText] - text to be displayed in back button.  i.e. "Back to Subcribers"
 * @param {string} [backPath] - Url to navigate to when clicking on back button. Can be relative or absolute url.
 */

const WizardBackButton = ({
  backText: backTextProp,
  backPath: backPathProp,
  'data-testid': testId
}) => {
  const { search } = useLocation();
  const { backPath: backPathParam, backText: backTextParam } = qs.parse(search);
  const backPath = backPathParam ? decodeURI(backPathParam) : backPathProp;
  const backText = backTextParam ? decodeURI(backTextParam) : backTextProp;

  if (!backPath || !backText) return null;

  return (
    <Button color={Button.COLORS.NEUTRAL} to={backPath} data-testid={testId}>
      {backText}
    </Button>
  );
};

WizardBackButton.propTypes = {
  backText: PropTypes.string,
  backPath: PropTypes.string,
  'data-testid': PropTypes.string
};

export default WizardBackButton;
